import { computed, onMounted, onUnmounted, ref } from "vue";

const ratio4to3 = 4 / 3;

const calculate4to3Dimensions = (fullWidth: number, fullHeight: number, ratio: number) => {
  if (fullWidth / fullHeight > ratio) {
    return {
      width: fullHeight * ratio,
      height: fullHeight,
    };
  }
  return {
    width: fullWidth,
    height: fullWidth * ratio,
  };
};

const calculateFullWindow4to3RatioDimensions = () =>
  calculate4to3Dimensions(window.innerWidth || 800, window.innerHeight || 600, ratio4to3);

const calculateFullScreen4to3RatioDimensions = () => {
  const screenHeight = window.screen.height || 600;
  return calculate4to3Dimensions(
    window.screen.width || 800,
    window.navigator.platform.includes("Mac") ? screenHeight - 37 : screenHeight,
    ratio4to3,
  );
};

const useFullWindow4to3RatioDimensions = () => {
  const dimensions = ref(calculateFullWindow4to3RatioDimensions());

  const handleResize = () => {
    dimensions.value = calculateFullWindow4to3RatioDimensions();
  };

  onMounted(() => {
    window.addEventListener("resize", handleResize);
  });

  onUnmounted(() => {
    window.removeEventListener("resize", handleResize);
  });

  return dimensions;
};

export const useFullWindow4to3RatioDimensionStyle = () => {
  const dimensions = useFullWindow4to3RatioDimensions();
  return computed(() => `width: ${dimensions.value.width}px; height: ${dimensions.value.height}px`);
};

const useFullScreen4to3RatioDimensions = () => {
  const dimensions = ref(calculateFullScreen4to3RatioDimensions());

  const handleResize = () => {
    dimensions.value = calculateFullScreen4to3RatioDimensions();
  };

  onMounted(() => {
    window.addEventListener("resize", handleResize);
  });

  onUnmounted(() => {
    window.removeEventListener("resize", handleResize);
  });

  return dimensions;
};

export const useFullScreen4to3RatioDimensionStyle = () => {
  const dimensions = useFullScreen4to3RatioDimensions();
  return computed(() => `width: ${dimensions.value.width}px; height: ${dimensions.value.height}px`);
};
